// Typed accessors over the runtime config from public/config.js
// (window.__APP_CONFIG__, overridden per cluster by the fineco-aikit-config ConfigMap).

const isOn = (value: boolean | 'true' | 'false' | undefined): boolean => value === true || value === 'true';

/** Local only: the upload is answered by the fixtures, the api is never called. */
export const isPortfolioDocUploadMockEnabled = (): boolean => isOn(window.__APP_CONFIG__?.PORTFOLIO_DOC_UPLOAD_MOCK);

/**
 * The chat SDK's `gatewayResume`, so a message sent while a gateway stops is resent or followed instead of lost. Off by
 * default. On only where API_BASE_URL is an agent gateway that sends its WebSocket keepalive (agent-gateway #36), or
 * an ACE drained for the switch to one (it stores nothing): a live ACE has no resend dedupe and could store a message
 * twice.
 */
export const isGatewayResumeEnabled = (): boolean => isOn(window.__APP_CONFIG__?.GATEWAY_RESUME);
